import { type ReactElement } from 'react'
import { NotReady, PermissionContent } from '@components'
import { usePermissions } from '@front/model'
import { Stack } from '@mantine/core'
import { type WithCompanyId } from '@terros/common'

export const CompanyPermissions = ({ companyId }: WithCompanyId): ReactElement => {
  const { data: permissionList, isLoading } = usePermissions(companyId)

  if (isLoading || !permissionList) return <NotReady isLoading={isLoading} />

  return (
    <Stack>
      <PermissionContent entityId={companyId} />
    </Stack>
  )
}
